import * as React from "react";
import type { SVGProps } from "react";
const SvgWiFi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.3 8.79c5.06-5.06 13.32-5.06 18.41 0h.01a.996.996 0 1 1-1.41 1.41C15 5.92 8 5.92 3.72 10.2c-.2.19-.45.29-.71.29a.996.996 0 0 1-.71-1.7Zm2.82 2.83a.996.996 0 1 0 1.41 1.41 7.007 7.007 0 0 1 9.9 0c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41c-3.51-3.51-9.22-3.51-12.73 0Zm2.83 4.24a.996.996 0 0 1 0-1.41 5.003 5.003 0 0 1 7.07 0c.39.39.39 1.02 0 1.41-.2.19-.45.29-.71.29-.26 0-.51-.09-.71-.29a3 3 0 0 0-4.24 0 .996.996 0 0 1-1.41 0Zm3.54 1.13h.01c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .44-1 .99-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWiFi;
